import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIHeaderComponent } from './ui-header.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    UIHeaderComponent
  ],
  exports: [
    UIHeaderComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule
  ]
})
export class UIHeaderModule { }
